import React from "react";
import { Grid, Menu, Segment } from "semantic-ui-react";
import { NavLink, useRouteMatch, Switch, Redirect } from "react-router-dom";
import { PrivateRouteAdmin } from "../../../components/PrivateRouteAdmin";
import { Users } from "./Users";
import { Companies } from "./Companies";
import { Invitations } from "./Invitations";

const Administrator = () => {
  let { path, url } = useRouteMatch();

  return (
    <Grid>
      <Grid.Column width={4}>
        <Menu pointing vertical>
          <Menu.Item name="users" as={NavLink} to={`${url}/users`}>
            <i className="mdi mdi-account-multiple"></i>
            <span style={{ paddingLeft: "10px" }}>Administrar usuarios</span>
          </Menu.Item>
          <Menu.Item name="companies" as={NavLink} to={`${url}/companies`}>
            <i className="mdi mdi-city"></i>
            <span style={{ paddingLeft: "10px" }}>Administrar compañías</span>
          </Menu.Item>
          {/* <Menu.Item name="access" as={NavLink} to={`${url}/access`}>
            Administrar acceso
          </Menu.Item> */}
          <Menu.Item name="invitations" as={NavLink} to={`${url}/invitations`}>
            <i className="mdi mdi-ticket-account"></i>
            <span style={{ paddingLeft: "10px" }}>
              Administrar invitaciones
            </span>
          </Menu.Item>
        </Menu>
      </Grid.Column>

      <Grid.Column stretched width={12}>
        <Segment>
          <Switch>
            <Redirect exact from={path} to={`${path}/users`} />
            <PrivateRouteAdmin path={`${path}/users`} component={Users} />
            <PrivateRouteAdmin
              path={`${path}/companies`}
              component={Companies}
            />
            {/* <PrivateRouteAdmin path={`${path}/access`} component={Access} /> */}
            <PrivateRouteAdmin
              path={`${path}/invitations`}
              component={Invitations}
            />
          </Switch>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default Administrator;
